import React from 'react';

import {jobFailedIcon, jobRunManualIcon, jobRunAutoSpin, jobSuccessIcon, jobPendingIcon} from '../../components/Alerts';


const JOB_STATUS_DRAFT = 0;
const JOB_STATUS_LINK_FOR_UPLOAD = 1;
const JOB_STATUS_RUN = 20;
const JOB_STATUS_FAILED = -20;
const JOB_STATUS_SUCCESS = 40;


export default class JobStatusComponent extends React.Component {

    render() {
        const {data, isManualStep} = this.props;

        let element = null;
  
        if (data.status == JOB_STATUS_FAILED) {
          element = jobFailedIcon;
        } else if (data.status == JOB_STATUS_SUCCESS) {
          element = jobSuccessIcon;
        } else if (data.status == JOB_STATUS_RUN) {
          if (isManualStep) {
            element = jobRunManualIcon;
          } else {
            element = jobRunAutoSpin;
          }
        } else if (data.status == JOB_STATUS_DRAFT || data.status == JOB_STATUS_LINK_FOR_UPLOAD) {
          element = jobPendingIcon;
        }
        return element;
    }
}



// WEBPACK FOOTER //
// ./src/views/Cases/statusComponent.jsx